export const showFilterAsAutoComplete = 10;

export const maxFilterFavorites = 5;

export const varTypesUsingContains = ['6', '13', '14', '35', '36', '37'];
